export default "<div class=\"search-main\">\n    <div class=\"ad-search\"><app-advancesearch></app-advancesearch></div>\n</div>"